import { CSS_PROPERTY, getCssBasedOnRtl } from '../../../styles';

import styled from 'styled-components';

export const Container = styled.div`
  align-items: center;
  display: inline-flex;
  margin-top: ${({ theme }) => theme.spacing.base.xxs};
  margin-bottom: ${({ theme }) => theme.spacing.base.md};
  ${({ theme }) => getCssBasedOnRtl(theme, CSS_PROPERTY.MARGIN_RIGHT, theme.spacing.base.md)};
`;

export const Label = styled.div`
  color: ${({ theme }) => theme.typography.color.primary};
  font-size: ${({ theme }) => theme.typography.size.medium};
  font-weight: ${({ theme }) => theme.typography.weight.bold};
  margin-left: ${({ theme }) => theme.spacing.base.xxs};
`;

export const ToggleContainer = styled.div`
  display: flex;
  flex: 1 0 auto;
`;
